import { StyledIconDefaultButton } from "./StyledComponents/Buttons";

export interface ButtonIconPropsApi {
  id?: string;
  icon: string;
  alt: string;
  onClick?: (event: any) => any;
  height?: string;
  width?: string;
  margin?: string;
  padding?: string;
  withShadow?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  withBorder?: boolean;
  bg?: string;
  title?: string;
}

export const IconDefaultButton: React.FC<ButtonIconPropsApi> = (
  props: ButtonIconPropsApi
) => {
  return (
    <StyledIconDefaultButton
      type={props.type}
      height={props.height}
      width={props.width}
      margin={props.margin}
      padding={props.padding}
      $with_shadow={props.withShadow}
      id={props.id}
      onClick={props.onClick}
      $with_border={props.withBorder}
      $bg={props.bg}
    >
      <img src={props.icon} alt={props.alt} title={props.title} />
    </StyledIconDefaultButton>
  );
};
